module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading_basic_data":"Loading basic data","waiting_for_backend":"Connecting to Celus server"},"cs":{"loading_basic_data":"Loading basic data","waiting_for_backend":"Connecting to Celus server"}}')
  delete Component.options._Ctor
}
